import React, { Component } from "react";
import FormServices from "../../Services/FormServices";
import { ShowBlocker } from "../../Components/LoaderComponent/LoaderComponent";
import { loadFromLocalStorage } from "../../Common/Validation/LocalStorage";
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Card, CardContent, Checkbox, Container, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, OutlinedInput, Select, TextField, Tooltip, Typography } from "@mui/material";
import { TableColumn } from "react-data-table-component";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import DataGrid from "../../Components/DataGrid/DataGrid";
import CustomMaterialMenu from "../../Components/DataGrid/Plugins/CustomMaterialMenu/CustomMaterialMenu";
import Swal from "sweetalert2";
import withReactContent from 'sweetalert2-react-content';

import './PDFUploader.css';
import { amountFormat } from "../../Components/helper";


const MySwal = withReactContent(Swal);


interface IBasicChart {
  examinationActive: boolean,
  extensionDate: string,
  isExtensionActive: boolean,
  isLienActive: boolean,
  isReturnFiled: boolean,
  isCollectionActive: boolean,
  lienFiledDate: string,
  assessedBal: string,
  total: string,
  filingStatus: string
}

export interface EligiblePlan {
  planName: string;
  planId: number;
  details: string;
  isEligible: boolean;
  recommendation: string;
  description: string;
}



interface ItollEvents {
  start: string,
  startExplanation: string,
  startCode: string,
  end: string,
  endCode: string,
  endExplanation: string,
  additionalTolledDays: string
  isValid: boolean
}

export interface CSEDDeductionOrAddition {
  code: string;
  explanation: string;
  cycle: string;
  date: string; // format: "MM-DD-YYYY"
  amount: number;
}

export interface BaseCSED {
  code: string;
  explanation: string;
  cycle: string;
  date: string;  // format: "MM-DD-YYYY"
  amount: number;
  originalIndex: number;
  estimatedStatute: string;
  deductions: CSEDDeductionOrAddition[];
  additions: CSEDDeductionOrAddition[];
  sameDate: CSEDDeductionOrAddition[];
}

interface IEachYearDetails {
  tolledEvents: ItollEvents[],
  baseCSED: BaseCSED[],
  tolledDays: number,
  basicChart: IBasicChart,
  year: string

}

interface Istate {
  fileName: string,
  base64String: any,
  tollingEvents: ItollEvents[],
  baseCSED: BaseCSED[],
  tolledDays: number,
  tin: string,
  firstName: string,
  lastName: string,
  taxYear: string[],
  taxYearOptions: string[],
  accessToken: string,
  allYearDetails: IEachYearDetails[],
  dmi: string,
  isLLA: boolean,
  isOICEligible: boolean,
  eligiblePlans: EligiblePlan[],
  isTollCompleted: boolean,
  minEmi: string
  requestedId: string;
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};


class PDFUploader extends Component<{}, Istate> {
  quesAndAnsShad: { question: string, answer: string }[] = [];
  constructor(props: any) {
    super(props);
    const start = 2012;
    const end = new Date().getFullYear() + 2;
    const taxYearoptions = Array.from(
      { length: end - start + 1 },
      (val, i) => (start + i).toString()
    );
    this.state = {
      tin: '',
      firstName: '',
      lastName: '',
      taxYear: [],
      base64String: "",
      fileName: "",
      tollingEvents: [],
      baseCSED: [],
      allYearDetails: [],
      tolledDays: 0,
      accessToken: '',
      taxYearOptions: taxYearoptions,
      requestedId: '',
      dmi: '',
      isLLA: false,
      isOICEligible: false,
      eligiblePlans:[],
      isTollCompleted: true,
      minEmi:''
    };
  }


  ///... columns present in basic chart table
  private basicChartFormColumns: TableColumn<IEachYearDetails>[] = [
    {
      name: 'Year',
      maxWidth: '100px',
      selector: (row: IEachYearDetails) => row.year,
      wrap: false
    },
    {
      name: 'Filing Status',
      maxWidth: '250px',
      cell: (row: IEachYearDetails) => (
        <div>
          <Tooltip title={row.basicChart.filingStatus}>
            <div style={{ textAlign: 'center' }}>{row.basicChart.filingStatus}</div>
          </Tooltip>
        </div>
      ),
      wrap: false

    },
    {
      name: 'Return Filed',
      maxWidth: '100px',
      selector: (row: IEachYearDetails) => row.basicChart.isReturnFiled ? 'Yes' : 'No',
      wrap: false

    },
    {
      name: 'Extension Active',
      maxWidth: '100px',
      selector: (row: IEachYearDetails) => row.basicChart.isExtensionActive ? 'Yes' : 'No',
      wrap: false
    },
    {
      name: 'Extension Date',
      maxWidth: '120px',
      selector: (row: IEachYearDetails) => row.basicChart.extensionDate ? row.basicChart.extensionDate : 'NA',
      wrap: false,
    },
    {
      name: 'Lien Active',
      maxWidth: '100px',
      selector: (row: IEachYearDetails) => row.basicChart.isLienActive ? 'Yes' : 'No',
      wrap: false
    },
    {
      name: 'Lien Filed Date',
      maxWidth: '120px',
      selector: (row: IEachYearDetails) => row.basicChart.lienFiledDate ? row.basicChart.lienFiledDate : 'NA',
      wrap: false
    },
    {
      name: 'Collection Active',
      maxWidth: '100px',
      selector: (row: IEachYearDetails) => row.basicChart.isCollectionActive ? 'Yes' : 'No',
      wrap: false
    },
    {
      name: 'Examination Active',
      maxWidth: '100px',
      // selector: (row: IEachYearDetails) => row.basicChart.examinationActive ? 'Yes' : 'No',
      cell: (row: IEachYearDetails) => <div style={{ whiteSpace: 'nowrap' }}>{row.basicChart.examinationActive ? 'Yes' : 'No'}</div>,
      wrap: false
    },
    {
      name: 'Assessed Balance',
      maxWidth: '120px',
      cell: (row: IEachYearDetails) => <div style={{
        textAlign: "right",
        width: '100%'
      }}>{row.basicChart.assessedBal}</div>,
      wrap: false,
    },
    {
      name: 'Accrued Balance',
      maxWidth: '120px',
      cell: (row: IEachYearDetails) => <div style={{
        textAlign: "right",
        width: '100%'
      }}>{row.basicChart.total}</div>,
      wrap: false
    },
    {
      name: 'CSED - 150',
      maxWidth: '120px',
      cell: (row: IEachYearDetails) => <div style={{
        textAlign: "right",
        width: '100%'
      }}>{row.baseCSED.filter(x => x.code == '150')[0]?.estimatedStatute && row.baseCSED.filter(x => x.code == '150')[0]?.estimatedStatute.toLowerCase() != 'unknown' ? row.baseCSED.filter(x => x.code == '150')[0]?.estimatedStatute.split('T')[0] : 'NA'}</div>,
      wrap: false
    },
    {
      name: 'Rem. Months - 150',
      maxWidth: '120px',
      cell: (row: IEachYearDetails) => {
        let statute = row.baseCSED.filter(x => x.code == '150')[0]?.estimatedStatute.toLowerCase()
        if (statute && statute != 'unknown') {
          const startDate = new Date();
          const endDate = new Date(statute);

          return <div style={{
            textAlign: 'right', width: '100%'
          }}> {endDate.getMonth() -
            startDate.getMonth() +
            12 * (endDate.getFullYear() - startDate.getFullYear())} </div>
        }
        return <div style={{
          textAlign: 'right'
        }}>NA</div>;
      },
      wrap: false
    },
    {
      name: 'CSED - 290',
      maxWidth: '120px',
      cell: (row: IEachYearDetails) => <div style={{
        textAlign: "right",
        width: '100%'
      }}>{row.baseCSED.filter(x => x.code == '290')[0] && row.baseCSED.filter(x => x.code == '290')[0]?.estimatedStatute.toLowerCase() != 'unknown' ? row.baseCSED.filter(x => x.code == '290')[0]?.estimatedStatute.split('T')[0] : 'NA'}</div>,
      wrap: false
    },
    {
      name: 'Rem. Months - 290',
      maxWidth: '120px',
      cell: (row: IEachYearDetails) => {
        let statute = row.baseCSED.filter(x => x.code == '290')[0]?.estimatedStatute.toLowerCase();
        if (statute && statute != 'unknown') {
          const startDate = new Date();
          const endDate = new Date(statute);

          return <div style={{
            textAlign: 'right', width: '100%'
          }}> {endDate.getMonth() -
            startDate.getMonth() +
            12 * (endDate.getFullYear() - startDate.getFullYear())} </div>
        }
        return <div style={{
          textAlign: 'right', width: '100%'
        }}> NA </div>;
      },
      wrap: false
    },
    {
      name: 'CSED - 300',
      maxWidth: '120px',
      cell: (row: IEachYearDetails) => <div style={{
        textAlign: "right",
        width: '100%'
      }}>{row.baseCSED.filter(x => x.code == '300')[0] && row.baseCSED.filter(x => x.code == '300')[0]?.estimatedStatute.toLowerCase() != 'unknown' ? row.baseCSED.filter(x => x.code == '300')[0]?.estimatedStatute.split('T')[0] : 'NA'}</div>,
      wrap: false
    },
    {
      name: 'Rem. Months - 300',
      maxWidth: '120px',
      cell: (row: IEachYearDetails) => {
        let statute = row.baseCSED.filter(x => x.code == '300')[0]?.estimatedStatute.toLowerCase();
        if (statute && statute != 'unknown') {
          const startDate = new Date();
          const endDate = new Date(statute);

          return <div style={{
            textAlign: 'right', width: '100%'
          }}> {endDate.getMonth() -
            startDate.getMonth() +
            12 * (endDate.getFullYear() - startDate.getFullYear())} </div>
        }
        return <div style={{
          textAlign: 'right', width: '100%'
        }}> NA </div>;
      },
      wrap: false
    },

  ];

  ///... columns present in tolling event table
  private tollingEventColumn: TableColumn<ItollEvents>[] = [
    {
      name: 'Tolling Start Code',
      minWidth: '150px',
      selector: (row: ItollEvents) => row.startCode,
      wrap: false
    },
    {
      name: 'Description Of Start',
      minWidth: '150px',
      selector: (row: ItollEvents) => row.startExplanation,
      cell: (row: ItollEvents) => (
        <Tooltip title={row.startExplanation}>
          <div>{row.startExplanation}</div>
        </Tooltip>
      ),
      wrap: false
    },
    {
      name: 'Start Date',
      minWidth: '150px',
      selector: (row: ItollEvents) => row.start,
      wrap: false
    },

    {
      name: 'Tolling End Code',
      minWidth: '150px',
      selector: (row: ItollEvents) => row.endCode,
      wrap: false
    },
    {
      name: 'Description Of End',
      minWidth: '150px',
      selector: (row: ItollEvents) => row.endExplanation,
      cell: (row: ItollEvents) => (
        <Tooltip title={row.endExplanation}>
          <div>{row.endExplanation}</div>
        </Tooltip>
      ),
      wrap: false
    },
    {
      name: 'End Date',
      minWidth: '150px',
      selector: (row: ItollEvents) => row.end,
      wrap: false
    },
    {
      name: 'Actual Tolled Days',
      minWidth: '150px',
      selector: (row: ItollEvents) => {
        if (row.start && row.end) {
          const startDate = new Date(row.start);
          const endDate = new Date(row.end);

          const timeDiff = endDate.getTime() - startDate.getTime();
          const dayDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24)); // Convert ms to days

          return dayDiff.toString();
        }
        return '';
      },
      wrap: false
    },
    {
      name: 'Additional Tolled Days',
      minWidth: '150px',
      selector: (row: ItollEvents) => row.additionalTolledDays,
      wrap: false
    },

  ];

  ///... columns present in CSED table
  private csedColumns: TableColumn<BaseCSED>[] = [
    {
      name: 'Code',
      maxWidth: '80px',
      selector: (row: BaseCSED) => row.code,
      wrap: false
    },
    {
      name: 'Description ',
      maxWidth: '350px',
      selector: (row: BaseCSED) => row.explanation,
      cell: (row: BaseCSED) => (
        <Tooltip title={row.explanation}>
          <div>{row.explanation}</div>
        </Tooltip>
      ),
      wrap: false
    },
    {
      name: 'Cycle',
      maxWidth: '120px',
      selector: (row: BaseCSED) => row.cycle,
      cell: (row: BaseCSED) => (
        <Tooltip title={row.cycle}>
          <div>{row.cycle}</div>
        </Tooltip>
      ),
      wrap: false
    },

    {
      name: 'Date',
      maxWidth: '120px',
      selector: (row: BaseCSED) => row.date,
      wrap: false
    },
    {
      name: 'Amount',
      maxWidth: '120px',
      selector: (row: BaseCSED) => row.amount,
      cell: (row: BaseCSED) => <div style={{
        width: '100%',
        textAlign: 'center'
      }}> {amountFormat(row.amount, 'en-US', 'USD')}</div>,
      wrap: false
    },
    {
      name: 'Estimated CSED',
      maxWidth: '120px',
      selector: (row: BaseCSED) => row.estimatedStatute.split('T')[0],
      wrap: false
    },
    {
      name: 'Remaining Months',
      maxWidth: '120px',
      selector: (row: BaseCSED) => {
        if (row.date && row.estimatedStatute.toLowerCase() != 'unknown') {
          const startDate = new Date();
          const endDate = new Date(row.estimatedStatute);

          return endDate.getMonth() -
            startDate.getMonth() +
            12 * (endDate.getFullYear() - startDate.getFullYear());
        }
        return '';
      },
      wrap: false
    },
    {
      maxWidth: '50px',
      cell: row => <CustomMaterialMenu
        fontSize="small"
        multiPopoverItems={[
          {
            key: "added",
            label: "Transactions Added",
          },
          {
            key: "deducted",
            label: "Transactions Deducted",
          },
          {
            key: "sameDate",
            label: "Transactions Assessed On Same Date",
          }
        ]}
        onPopoverClick={(key_: string, label_: string) => {
          this.openAdditionalCSEDInfo(row, key_, label_);
        }} />,

      allowOverflow: true,
      button: true,
      width: '56px'
    }
  ];


  ///... additional columns to show added / deducted /same date - transcation codes
  private additionalCSEDColumns: TableColumn<CSEDDeductionOrAddition>[] = [
    {
      name: 'Code',
      minWidth: '150px',
      selector: (row: CSEDDeductionOrAddition) => row.code,
      wrap: false
    },
    {
      name: 'Description ',
      minWidth: '150px',
      selector: (row: CSEDDeductionOrAddition) => row.explanation,
      cell: (row: CSEDDeductionOrAddition) => (
        <Tooltip title={row.explanation}>
          <div>{row.explanation}</div>
        </Tooltip>
      ),
      wrap: false
    },
    {
      name: 'Cycle',
      minWidth: '150px',
      selector: (row: CSEDDeductionOrAddition) => row.cycle,
      wrap: false
    },

    {
      name: 'Date',
      minWidth: '150px',
      selector: (row: CSEDDeductionOrAddition) => row.date,
      wrap: false
    },
    {
      name: 'Amount',
      minWidth: '150px',
      selector: (row: CSEDDeductionOrAddition) => ` ${amountFormat(row.amount, 'en-US', 'USD')}`,
      wrap: false
    },
  ];


  async componentDidMount() {
    ///... check token in local storage
    const accesstoken = await loadFromLocalStorage('accessToken');
    ///... if available get user details otherwise re-direct to login page
    if (accesstoken) {
      this.setState({
        accessToken: accesstoken.toString()
      }, () => {
      });
    }
    else {
      localStorage.clear();
      window.location.href = '/'
    }
  }

  /**
   * To handle onChange event of Tax year select drop-down
   * @param event 
   */
  selectHandleChange = (event: any) => {
    try {
      const {
        target: { value },
      } = event;
      this.setState({ taxYear: typeof value === 'string' ? value.split(',') : value });
    }
    catch (ex) {
    }

  };

  /**
   * Submit user details to API and fetch 
   * tolling, CSED and other realated details 
   */
  submitUserDetails = () => {
    FormServices.UploadTPData({ tin: this.state.tin, firstName: this.state.firstName, lastName: this.state.lastName, taxYear: this.state.taxYear }, this.state.accessToken).then((r) => {
      if (r.ok) {
        r.json().then(resp => {
          this.setState({
            requestedId: resp.requestId
          }, () => {
            this.getRequestedIRSDetails();
          })
          // this.setState({ allYearDetails: resp });
        }, () => {
          ///... post execution once state is set
        }).catch(err => {
          Swal.fire("Error", err.message ? err.message : 'Failed due to technical difficulties', "error");
        });

        /*r.json().then(resp => {
          this.setState({ allYearDetails: resp });
        }, () => {
          ///... post execution once state is set
        }).catch(err => {
          Swal.fire("Error", err.message ? err.message : 'Failed due to technical difficulties', "error");
        });*/

      }
    });
  }


  public isRequestInProgress = false; // Flag to prevent multiple simultaneous requests
  public timeoutId: any = null;
  /**
   * get response for the submitted request
   */
  getRequestedIRSDetails = () => {
    if (this.isRequestInProgress) return;  // Prevent a new request if the previous one is still in progress

    this.isRequestInProgress = true; // Set flag to true to mark request in progress

    FormServices.getTPData({ transactionId: this.state.requestedId }, this.state.accessToken).then((r) => {
      if (r.ok) {
        r.json().then(resp => {
          console.log("API Response:", resp);  // Log API response for debugging
          ShowBlocker(false);
          if (resp.status == 200) {
            if (resp.data.message) {
              this.isRequestInProgress = false;  // Reset flag after successful data fetching
              Swal.fire("Error", resp.data.message ? `${resp.data.message}. Please try again with another record.` : 'Failed due to technical difficulties', "error");
            }
            else {
              this.setState({ allYearDetails: resp.data });
              this.isRequestInProgress = false;  // Reset flag after successful data fetching
            }
          }
          else {
            this.isRequestInProgress = false;  // Reset flag after successful data fetching
            ShowBlocker(true);
            if (this.timeoutId) clearTimeout(this.timeoutId);  // Clear the previous timeout
            this.timeoutId = setTimeout(() => {
              this.getRequestedIRSDetails();
            }, 5000);
          }
          // this.setState({ allYearDetails: resp });
        }, () => {
          ///... post execution once state is set
        }).catch(err => {
          ShowBlocker(false);
          Swal.fire("Error", err.message ? err.message : 'Failed due to technical difficulties', "error");
          this.isRequestInProgress = false; // Reset flag on error as well
        });

      }
      else {
        // Handle failure if fetch fails (e.g., network issues)
        ShowBlocker(false);
        Swal.fire("Error", 'Failed to fetch data. Please check your connection and try again.', "error");
        this.isRequestInProgress = false; // Reset flag on fetch failure
      }
    })
      .catch(err => {
        // Catch errors during the fetch itself
        ShowBlocker(false);
        Swal.fire("Error", err.message ? err.message : 'Failed due to technical difficulties', "error");
        this.isRequestInProgress = false; // Reset flag on network error
      });
  }

    getEligiblePlans = () => {
    FormServices.getEligiblePlans({dmi: this.state.dmi, isLLA: this.state.isLLA, isOICEligible: this.state.isOICEligible}, this.state.accessToken).then((r) => {
      if (r.ok) {
        r.json().then(resp => {
          this.setState({ eligiblePlans: resp.eligiblePlans, isTollCompleted: resp.isInvalid, minEmi: resp.minEMI });
        }, () => {
          ///... post execution once state is set
          this.showPlans();
        }).catch(err => {
          Swal.fire("Error", err.message ? err.message : 'Failed due to technical difficulties', "error");
        });
      }
    });
  }



  /**
   * Additional details to show added. deducted, same date transactions code 
   * for each assessments in respective years
   * @param row 
   * @param key 
   * @param label 
   */
  openAdditionalCSEDInfo(row: BaseCSED, key: string, label: string) {
    let data = [];
    if (key == 'added') {
      data = row.additions;
    }
    else if (key == 'deducted') {
      data = row.deductions;
    }
    else {
      data = row.sameDate;
    }
    MySwal.fire({
      title: label,
      showConfirmButton: false,
      showCloseButton: true,
      heightAuto: false,
      customClass: {
        popup: 'csed-swal-popup',
      },

      html: (
        <div style={{ maxHeight: '90%', width: '100%', overflowY: 'auto' }}>
          <DataGrid
            columns={this.additionalCSEDColumns}
            data={data}
          />
        </div>
      ),
    });
  }

  /**
   * 
   * @returns 
   */
  renderBasicChart() {
    try {
      return (
        <div className='body-sub-contianer table-container'>
          <DataGrid
            columns={this.basicChartFormColumns}
            data={this.state.allYearDetails}
          />
        </div>
      )
    }
    catch (ex) {

    }
  }


  renderTollingEventsEachYear() {
    try {

      return this.state.allYearDetails.map((item) => (
        <Accordion>
          <AccordionSummary
            expandIcon={<ArrowDropDownIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography component="span">{item.year}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              <div className='body-sub-contianer table-container'>
                <DataGrid
                  columns={this.tollingEventColumn}
                  data={item.tolledEvents}
                />
              </div>
              <p>Total Tolled Days: {item.tolledDays}</p>
            </Typography>
          </AccordionDetails>
        </Accordion>
      )
      )

    }
    catch (ex) {

    }
  }

  renderBaseCSEDEachYear() {
    try {

      return this.state.allYearDetails.map((item) => (
        <Accordion>
          <AccordionSummary
            expandIcon={<ArrowDropDownIcon />}
            aria-controls="panel1-content"
            id="panel1-header">
            <Typography component="span">{item.year}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              <div className='body-sub-contianer table-container'>
                <DataGrid
                  columns={this.csedColumns}
                  data={item.baseCSED}
                />
              </div>
            </Typography>
          </AccordionDetails>
        </Accordion>
      )
      )

    }
    catch (ex) {

    }
  }

  checkToDisableButton() {
    return !this.state.tin || !this.state.firstName || !this.state.lastName || this.state.taxYear.length == 0
  }
  checkToDisablePlanButton() {
    return !this.state.dmi
  }

  showPlans = () => {
    const { eligiblePlans } = this.state;
    if (eligiblePlans.length == 0) return <h3>No Plans are eligible</h3>
    return     <>
    <h3>Min EMI : {this.state.minEmi ? `$ ${this.state.minEmi}` : '-'}</h3>
    {eligiblePlans.map((plan, index) => (
      
        <Card variant="outlined" style={{ borderRadius: "12px" }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              {plan.planName}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              ID: {plan.planId}
            </Typography>
            <Typography variant="body1" style={{ marginTop: "8px" }}>
              {plan.details}
            </Typography>
            <Typography variant="body2" style={{ marginTop: "8px" }}>
              {plan.description}
            </Typography>
            <Typography
              variant="body2"
              style={{ marginTop: "8px", fontWeight: "bold" }}
            >
              {plan.recommendation}
            </Typography>
            <Typography
              variant="body2"
              color={plan.isEligible ? "green" : "red"}
              style={{ marginTop: "8px" }}
            >
              Eligible: {plan.isEligible ? "Yes" : "No"}
            </Typography>
          </CardContent>
        </Card>
     
    ))}
 </>
   
  };


  render() {

    return (
      <>
        <h2>CSED Report</h2>
        <Container maxWidth={"lg"} sx={{
          margin: 'auto',
          width: '100%'
        }}>
          <Box
            width="100%"
            component="form"
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: 1,
              mt: 4,
              margin: 'auto',
              width: '100%',
              justifyContent: 'center'
            }}
            noValidate
            autoComplete="off"
          >
            <TextField
              label="TIN"
              variant="outlined"
              value={this.state.tin}
              size="medium"
              sx={{

                width: '33.33%'
              }}
              onChange={(e) => this.setState({ tin: e.target.value })}
            />

            <TextField
              label="First Name"
              variant="outlined"
              value={this.state.firstName}
              size="medium"
              sx={{

                width: '33.33%'
              }}
              onChange={(e) => this.setState({ firstName: e.target.value })}
            />
          </Box>
          <Box
            component="form"
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: 1,
              mt: 4,
              justifyContent: 'center',
            }}
            noValidate
            autoComplete="off"
          >
            <TextField
              label="Last Name"
              variant="outlined"
              value={this.state.lastName}
              size="medium"
              sx={{
                width: '33.33%'
              }}
              onChange={(e) => this.setState({ lastName: e.target.value })}
            />

            <FormControl sx={{ width: '33.33%' }}>
              <InputLabel id="demo-multiple-name-label">Tax Years</InputLabel>
              <Select
                labelId="demo-multiple-name-label"
                id="demo-multiple-name"
                multiple
                sx={{ width: '100%' }}
                value={this.state.taxYear}
                onChange={this.selectHandleChange}
                input={<OutlinedInput label="Tax Years" />}
                MenuProps={MenuProps}
              >
                {this.state.taxYearOptions.map((year) => (
                  <MenuItem key={year} value={year}>
                    {year}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

          </Box>
          <Box
            component="form" noValidate autoComplete="off"
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: 2,
              mt: 4,
            }}>
            <Button
              variant="contained" onClick={this.submitUserDetails} size="medium"
              disabled={this.checkToDisableButton()}
              sx={{
                width: '150px',
                margin: 'auto',
                textTransform: 'none',
                borderRadius: '10px',
                backgroundColor: 'var(--secondary-main)',
                color: 'var(--primary-main)',
              }}> Submit </Button>
          </Box>
        </Container>
        <Container maxWidth={"lg"} sx={{
          margin: '20px auto',
          width: '100%'
        }}>
          <TextField
            label="Disposable Income"
            variant="outlined"
            value={this.state.dmi}
            size="medium"
            sx={{
              width: '33.33%'
            }}
            onChange={(e) => {
              const value = e.target.value;
              // Regex: only numbers, optional decimal, max 2 digits after decimal
              if (value === "" || /^\d+(\.\d{0,2})?$/.test(value)) {
                this.setState({ dmi: value });
              }
            }}
          />
          <FormControlLabel sx={{
            marginLeft: '10px'
          }}
            control={
              <Checkbox
                checked={this.state.isLLA}
                onChange={(e) => this.setState({ isLLA: e.target.checked })}
              />
            }
            label="Is Low Liquid Asset"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={this.state.isOICEligible}
                onChange={(e) => this.setState({ isOICEligible: e.target.checked })}
              />
            }
            label="IS OIC Eligible"
          />
          <Box>
            <Button
              variant="contained" onClick={this.getEligiblePlans} size="medium"
              disabled={this.checkToDisablePlanButton()}
              sx={{
                width: '150px',
                margin: '10px auto',
                textTransform: 'none',
                borderRadius: '10px',
                backgroundColor: 'var(--secondary-main)',
                color: 'var(--primary-main)',
              }}> Check Plans </Button>
          </Box>
        </Container >
        { this.showPlans()}
        {
         
          this.state.allYearDetails.length > 0 && <div>
            <div style={{ marginTop: '3px' }}>
              {this.state.allYearDetails.length > 0 && <h1 className="text-xl font-semibold" style={{ textAlign: 'left' }}>Basic Details</h1>}
              {this.state.allYearDetails.length > 0 && this.renderBasicChart()}
            </div>
            <div style={{ marginTop: '3rem' }}>
              {this.state.allYearDetails.filter(x => x.tolledEvents.length > 0).length > 0 && <h1 className="text-xl font-semibold" style={{ textAlign: 'left' }}>Tolling Event Details</h1>}
              {this.state.allYearDetails.filter(x => x.tolledEvents.length > 0).length > 0 && this.renderTollingEventsEachYear()}
            </div>
            <div style={{ marginTop: '3rem' }}>
              {this.state.allYearDetails.filter(x => x.baseCSED.length > 0).length > 0 && <h1 className="text-xl font-semibold" style={{ textAlign: 'left' }}>Base CSED Details</h1>}
              {this.state.allYearDetails.filter(x => x.baseCSED.length > 0).length > 0 && this.renderBaseCSEDEachYear()}
            </div>
          </div>
        }
      </>
    );

  }
}



export default PDFUploader;
